import SchedulePage from "./page";
export default SchedulePage;
